import React from "react";
import "./Footer.css";

function Footer({ onNavigate }) {
  const handleNav = (e, view) => {
    e.preventDefault();
    if (onNavigate) {
      onNavigate(view);
      window.scrollTo(0, 0); // Scroll to top when navigating
    }
  };

  return (
    <footer>
      <div className="footer-wrapper">
        <p>Copyright © 2023</p>
        <ul>
          <li>
            <a href="/" onClick={(e) => handleNav(e, 'listings')}>Home</a>
          </li>
          <li>
            <a href="/blog" onClick={(e) => handleNav(e, 'blog')}>Blog</a>
          </li>
          <li>
            <a href="/about" onClick={(e) => handleNav(e, 'about')}>About</a>
          </li>
          <li>
            <a href="/contact" onClick={(e) => handleNav(e, 'contact')}>Contact</a>
          </li>
          <li>
            <a href="/settings" onClick={(e) => handleNav(e, 'settings')}>Settings</a>
          </li>
        </ul>
      </div>
    </footer>
  );
}

export default Footer;
